export const formatCurrency = (amount: number, currency: string = "CAD"): string => {
	return new Intl.NumberFormat("en-CA", {
		style: "currency",
		currency,
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(amount);
};

export const formatCurrencyCompact = (amount: number, currency: string = "CAD"): string => {
	return new Intl.NumberFormat("en-CA", {
		style: "currency",
		currency,
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(amount);
};
